import { faArrowsTurnRight, faArrowTurnRight, faCopy, faTrash, faTurnDownRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Snackbar } from '@material-ui/core';
import React, { Dispatch, SetStateAction, useState } from 'react';
import VoxelButton from '../../../../../components/voxel/Buttons/VoxelButton';
import { ContentKeywordGq } from '../../../../../graphql/projects/models/ContentKeywordGq';
import { ContentTaskGq } from '../../../../../graphql/projects/models/ContentTaskGq';
import ContentKeywordsExistingUrlDialog from '../../Dialogs/ContentKeywordsExistingUrlDialog';
import ContentKeywordsNewUrlDialog from '../../Dialogs/ContentKeywordsNewUrlDialog';
import ContentKeywordsRemoveDialog from '../../Dialogs/ContentKeywordsRemoveDialog';
import ContentKeywordsSplitDialog from '../../Dialogs/ContentKeywordsSplitDialog';
import { useCopy } from '../../Dialogs/useCopy';

import { ContentTaskTableState } from './logic/useContentTaskTableState';

export interface ContentKeywordSpeedDialProps {
  clientUrl: string;
  selectActive: boolean;
  selectedCount: number;
  contentTask: ContentTaskGq;
  tableState: ContentTaskTableState;
  selectedIds: number[];
  setLocalItems: Dispatch<SetStateAction<ContentKeywordGq[]>>;
  reload: () => Promise<any>;
  localItems: ContentKeywordGq[];
}

const ContentKeywordSpeedDial: React.FC<ContentKeywordSpeedDialProps> = React.memo(
  ({
    selectActive,
    contentTask,
    tableState,
    reload,
    setLocalItems,
    localItems,
    selectedIds,
    selectedCount,
    clientUrl,
  }) => {
    // Other bars
    const [openNewUrlDialog, setOpenNewUrlDialog] = useState(false);
    const [openExistingUrlDialog, setopenExistingUrlDialog] = useState(false);
    const [openRemoveSelected, setOpenRemoveSelected] = useState(false);
    const [openSplitSelected, setOpenSplitSelected] = useState(false);
    const copyBag = useCopy({
      contentKeywords: localItems,
      selectedIds: selectedIds,
      tableState: tableState,
    });

    return (
      <>
        <div className='absolute left-0 -top-10 flex flex-row flex-nowrap gap-3'>
          <Snackbar
            message={'Copied to clipboard'}
            open={copyBag.showSnackbar}
            onClick={() => copyBag.setShowSnackbar(false)}
          />
          <Snackbar
            open={!!copyBag.errorSnackbarMessage?.length}
            onClick={() => copyBag.setErrorSnackbarMessage(undefined)}
            message={copyBag.errorSnackbarMessage}
          />
          <>
            <VoxelButton
              onClick={(event) => {
                event.stopPropagation();
                setopenExistingUrlDialog(true);
              }}
              disabled={!selectActive}
              size={'md'}
              endIcon={<FontAwesomeIcon icon={faTurnDownRight} />}
              title='Existing URL'
              tooltip='Move to existing url'
            />
            <VoxelButton
              title='New url'
              tooltip='Split to new URL'
              size='md'
              onClick={(event) => {
                event.stopPropagation();
                setOpenNewUrlDialog(true);
              }}
              disabled={!selectActive}
              endIcon={<FontAwesomeIcon icon={faArrowTurnRight} />}
            />
            <VoxelButton
              title='New url:s'
              tooltip='Split to new automatic URLs'
              size='md'
              onClick={(event) => {
                event.stopPropagation();
                setOpenSplitSelected(true);
              }}
              disabled={!selectActive}
              endIcon={<FontAwesomeIcon icon={faArrowsTurnRight} />}
            />
            <VoxelButton
              title='Remove'
              tooltip='Remove keywords from content plan'
              size='md'
              onClick={(event) => {
                event.stopPropagation();
                setOpenRemoveSelected(true);
              }}
              disabled={!selectActive}
              endIcon={<FontAwesomeIcon icon={faTrash} />}
            />
            <VoxelButton
              title='Copy'
              tooltip='Copy keywords'
              size='md'
              onClick={(event) => {
                event.stopPropagation();
                copyBag.handleCopy();
              }}
              disabled={!selectActive}
              endIcon={<FontAwesomeIcon icon={faCopy} />}
            />
          </>
        </div>
        <ContentKeywordsExistingUrlDialog
          clientUrl={clientUrl}
          selectActive={!!selectActive}
          contentTask={contentTask}
          selectedCount={selectedCount}
          selectedKeywordIds={selectedIds}
          setLocalItems={setLocalItems}
          tableState={tableState}
          reload={reload}
          openDialog={openExistingUrlDialog}
          setOpenDialog={setopenExistingUrlDialog}
        />
        <ContentKeywordsNewUrlDialog
          contentTask={contentTask}
          clientUrl={clientUrl}
          tableState={tableState}
          selectedKeywordIds={selectedIds}
          setLocalItems={setLocalItems}
          reload={reload}
          openDialog={openNewUrlDialog}
          setOpenDialog={setOpenNewUrlDialog}
        />
        <ContentKeywordsSplitDialog
          contentTask={contentTask}
          selectedCount={selectedCount}
          selectedKeywordIds={selectedIds}
          tableState={tableState}
          setLocalItems={setLocalItems}
          reload={reload}
          openDialog={openSplitSelected}
          setOpenDialog={setOpenSplitSelected}
        />
        <ContentKeywordsRemoveDialog
          contentTask={contentTask}
          selectedCount={selectedCount}
          selectedKeywordIds={selectedIds}
          tableState={tableState}
          setLocalItems={setLocalItems}
          reload={reload}
          openDialog={openRemoveSelected}
          setOpenDialog={setOpenRemoveSelected}
        />
      </>
    );
  }
);

export default ContentKeywordSpeedDial;
